'use strict';

const FetchHandler = require('../../deal/frontend/FetchHandler');

if (window.GMap == null) {
  window.GMap = {};
}

const lazyLoadMerchantLocations = {};

lazyLoadMerchantLocations.reload = data => {
  const { merchantHtml, merchantModalHtml, touchRequest } = data;

  if (merchantHtml.length) {
    if (window.GMap.isLoaded) {
      window.GMap.init(data, () => {});
    } else {
      window.GMap.asyncMapData = data;
    }
  }

  if (
    !touchRequest &&
    merchantModalHtml.length &&
    window.GIG &&
    window.GIG.Modal &&
    window.GIG.Modal.reloadBindings
  ) {
    window.GIG.Modal.reloadBindings(document.body, false);
  }
};

lazyLoadMerchantLocations.ajax_success = data => {
  if (!data) {
    return;
  }

  const {
    dealTitleMerchantInfoHtml,
    merchantHtml,
    merchantModalHtml,
    touchRequest,
  } = data;

  const $placeholder = document.querySelector(
    '#merchant-locations-placeholder'
  );

  if ($placeholder) {
    if (merchantHtml.length) {
      $placeholder.outerHTML = merchantHtml;
    } else {
      $placeholder.parentNode.removeChild($placeholder);
    }
  }

  const $dealSubtitle = document.querySelector('#deal-subtitle-container');
  if (dealTitleMerchantInfoHtml.length && $dealSubtitle) {
    $dealSubtitle.outerHTML = dealTitleMerchantInfoHtml;

    if (
      document.querySelector('.deal-subtitle') &&
      window.GIG &&
      window.GIG.Tooltip &&
      window.GIG.Tooltip.reloadBindings
    ) {
      window.GIG.Tooltip.reloadBindings('.deal-subtitle');
    }
  }

  if (touchRequest) {
    if (merchantModalHtml.length) {
      const $mainPane = document.getElementById('global-container');
      if ($mainPane) {
        $mainPane.insertAdjacentHTML('afterend', merchantModalHtml);
      }
    }
  } else {
    // add tooltips and modals potentially together (one less re-paint)
    let tooltipAndModalData = '';
    if (typeof merchantModalHtml === 'string') {
      tooltipAndModalData += merchantModalHtml;
    }

    if (tooltipAndModalData.length) {
      const $lastTooltip = [
        ...document.querySelectorAll('section.main, .tooltip'),
      ].pop();
      if ($lastTooltip) {
        $lastTooltip.insertAdjacentHTML('afterend', merchantModalHtml);
      }
    }
  }

  lazyLoadMerchantLocations.reload(data);
};

lazyLoadMerchantLocations.init = function (
  { clientSideMerchantLocations },
  done
) {
  if (
    !clientSideMerchantLocations ||
    !clientSideMerchantLocations.formattedUrl
  ) {
    done();
  }

  const handler = new FetchHandler({
    url: clientSideMerchantLocations.formattedUrl,
    requestOpts: { credentials: 'same-origin' },
    successHandlers: [lazyLoadMerchantLocations.ajax_success],
    errorHandlers: [
      () => {
        const $placeholder = document.querySelector(
          '#merchant-location-placeholder'
        );
        if ($placeholder) {
          $placeholder.parentNode.removeChild($placeholder);
        }
      },
    ],
  });
  handler.send();
  done();
};

module.exports = lazyLoadMerchantLocations;
